import RespondentFlowApi from "./respondentFlow.api";

const TOKEN_PATTERN = /^[0-9a-f]{32}$/i;

export const isValidRespondentToken = (token) => {
  return typeof token === "string" && TOKEN_PATTERN.test(token);
};

export const getRespondentSummary = async (token) => {
  return RespondentFlowApi.get(`/v1/ending/summary/${token}`);
};
